const endpoints = {
  login: (): string => `login`,
  refreshToken: (): string => `login/refreshToken`,
};

export default endpoints;
